import { matchAdjacentPairs } from "../../matching"
import type { Edge2dComputed, Face2dComputed } from "../../mesh"
import { whereWouldSegmentsIntersect } from "../collision"

export type GetTangledInsetFaceOptions = {
  insetEdgesSimplified: Edge2dComputed[]
}
export type GetTangledInsetFaceProcedure = {
  placeholder: null
}

export const getTangledInsetFace = ({
  insetEdgesSimplified,
}: GetTangledInsetFaceOptions): {
  result: Face2dComputed
  procedure: GetTangledInsetFaceProcedure
} => {
  const newNodes = matchAdjacentPairs(insetEdgesSimplified, (edgeA, edgeB) => {
    const node = whereWouldSegmentsIntersect(edgeA, edgeB)
    if (node === null) throw new Error(`No intersection found`)

    return node
  })

  const newArea = { nodes: newNodes }

  return { result: newArea, procedure: { placeholder: null } }
}
